import React, { useEffect, useState } from "react";
import { CardContent } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import LoadingSpinner from "../../../LoadingSpinner";
import {
  useGetAllUserListQuery,
  useGetAgentPerformanceReportQuery,
  useLazyGetAgentPerformanceReportDownloadQuery,
} from "../../../../Services/reports/tickets/ReportTickets";
import { toast } from "react-toastify";
import CsvDownloader from "react-csv-downloader";
import { AUTH_TOKEN } from "../../../../constants";

const getTodayDateString = () => new Date().toISOString().split("T")[0];
const isCurrentDateRange = (from: string, to: string) =>
  from === getTodayDateString() && to === getTodayDateString();
type ReportMode = "live" | "historical" | null;

const AgentPerformanceReport = () => {
  const navigate = useNavigate();
  const [reportType, setReportType] = useState("Inbound"); // Default to Inbound
  const [dateFrom, setDateFrom] = useState<string>("");
  const [dateTo, setDateTo] = useState<string>("");
  const [selectedAssignee, setSelectedAssignee] = useState<string>("");
  const [theUser, setTheUser] = useState<any>([]);
  const { data: userData, isLoading: userLoading } = useGetAllUserListQuery({});
  const [params, setParams] = useState<any>(null);
  const [dataRows, setDataRows] = useState<any[]>([]);
  const [localLoading, setLocalLoading] = useState(false);
  const [reportFetching, setReportFetching] = useState(false);
  const [totalRowsFromApi, setTotalRowsFromApi] = useState<number | null>(null);
  const [reportMode, setReportMode] = useState<ReportMode>(null);

  const {
    data: agentPerformanceData,
    isFetching: liveReportFetching,
    status: liveReportStatus,
  } = useGetAgentPerformanceReportQuery(params, {
    skip: !params || reportMode !== "live",
  });

  const [triggerAgentPerformanceDownload, { isFetching: downloadLoading }] =
    useLazyGetAgentPerformanceReportDownloadQuery();

  const reportingBaseUrl =
    process.env.REACT_APP_REPORTING_SERVER_URL || "https://reporting.bluewhirl.org";

  const [paginationModel, setPaginationModel] = useState({
    pageSize: 20,
    page: 0,
  });
  const columnsInbound: GridColDef[] = [
    {
      field: "srNo",
      headerName: "Sr.no",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "date",
      headerName: "Date",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "agentName",
      headerName: "Agent name",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalLoginTime",
      headerName: "Total login time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalInboundCalls",
      headerName: "Total calls offered",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    // {
    //   field: "totalCallsHandled",
    //   headerName: "Total Calls Handled",
    //   flex: 1,
    //   minWidth: 140,
    //   align: "center",
    //   headerAlign: "center",
    // },
    {
      field: "totalTalkTime",
      headerName: "Total talk time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalHandleTime",
      headerName: "Total handle time",
      flex: 1,
      minWidth: 150,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalAcw",
      headerName: "Total acw",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalHoldTime",
      headerName: "Total hold time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalBreakTime",
      headerName: "Total break time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "avgTalkTime",
      headerName: "Average Talk Time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "avgHoldTime",
      headerName: "Average hold time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "avgAcw",
      headerName: "Average acw",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "avgHandleTime",
      headerName: "Average handled time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "occupancy",
      headerName: "Occupancy",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
  ];

  const columnsOutbound: GridColDef[] = [
    {
      field: "srNo",
      headerName: "Sr.No",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "date",
      headerName: "Date",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "agentName",
      headerName: "Agent name",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    // {
    //   field: "totalLoginTime",
    //   headerName: "Total Login Time",
    //   flex: 1,
    //   minWidth: 140,
    //   align: "center",
    //   headerAlign: "center",
    // },
    {
      field: "totalOutboundCalls",
      headerName: "Total calls",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    // {
    //   field: "totalCallsHandled",
    //   headerName: "Total Calls Handled",
    //   flex: 1,
    //   minWidth: 140,
    //   align: "center",
    //   headerAlign: "center",
    // },
    {
      field: "totalTalkTime",
      headerName: "Total talk time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalHandleTime",
      headerName: "Total handle time",
      flex: 1,
      minWidth: 150,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalAcw",
      headerName: "Total ACW",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalHoldTime",
      headerName: "Total hold time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalBreakTime",
      headerName: "Total break time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "avgTalkTime",
      headerName: "Average talk time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "avgHoldTime",
      headerName: "Average hold time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "avgAcw",
      headerName: "Average acw",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "avgHandleTime",
      headerName: "Average handled time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "occupancy",
      headerName: "Occupancy",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
  ];

  const handleReportTypeChange: any = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    setReportType(event.target.value as string);
    setDataRows([]);
    setParams(null);
    setReportMode(null);
    setTotalRowsFromApi(null);
  };

  const handleDateFromChange = (event: any) => {
    setDateFrom(event.target.value);
  };

  const handleDateToChange = (event: any) => {
    setDateTo(event.target.value);
  };

  const handleChange: any = (event: React.ChangeEvent<{ value: unknown }>) => {
    setSelectedAssignee(event.target.value as string);
  };

  useEffect(() => {
    const dropdownHeadings = document.querySelectorAll(".dropdown-heading");
    dropdownHeadings.forEach((heading: any) => {
      heading.style.height = "50px";
    });
  }, []);

  useEffect(() => {
    const transformedData = userData?.map((user) => ({
      id: user.id,
      username: user.username,
    }));
    if (Array.isArray(userData)) {
      setTheUser(transformedData);
    } else {
      setTheUser([]); // Fallback to an empty array if it's not an array
    }
  }, [userData]);

  const handleSubmit = () => {
    if (!dateFrom) {
      toast.error('Please select "From Date"');
      return;
    }
    if (!dateTo) {
      toast.error('Please select "To Date"');
      return;
    }
    if (!selectedAssignee) {
      toast.error("Please select Assignee");
      return;
    }

    const isLive = isCurrentDateRange(dateFrom, dateTo);
    const queryParams: any = {
      gte: dateFrom,
      lte: dateTo,
      call_type: reportType === "Inbound" ? "inbound" : "outbound",
    };

    if (!isLive) {
      queryParams.page = 1;
      queryParams.page_size = paginationModel.pageSize;
    }

    if (selectedAssignee !== "All") {
      queryParams.user_id = selectedAssignee;
    }
    setReportMode(isLive ? "live" : "historical");
    setPaginationModel({ page: 0, pageSize: paginationModel.pageSize });
    setParams(queryParams);
  };

  const formatDuration = (duration: any) => {
    if (!duration || typeof duration !== "string") return "-";
    const parts = duration.split(":").map((part: string) => part.padStart(2, "0"));
    return parts.join(":");
  };

  const mapResultsToRows = (results: any[], callType: string, rowOffset: number) =>
    results.map((item: any, index: number) => {
      const sr = rowOffset + index + 1;
      return {
        id: sr,
        srNo: sr,
        date: item.date || "-",
        agentName: item.agent_name || "-",
        totalLoginTime: item.total_login_time
          ? formatDuration(item.total_login_time)
          : "-",
        totalInboundCalls:
          callType === "inbound" ? item.total_calls || "-" : undefined,
        totalOutboundCalls:
          callType === "outbound" ? item.total_calls || "-" : undefined,
        totalTalkTime: item.total_talk_time
          ? formatDuration(item.total_talk_time)
          : "-",
        avgTalkTime: item.avg_talk_time
          ? formatDuration(item.avg_talk_time)
          : "-",
        totalHoldTime: item.total_hold_time
          ? formatDuration(item.total_hold_time)
          : "-",
        avgHoldTime: item.avg_hold_time
          ? formatDuration(item.avg_hold_time)
          : "-",
        totalAcw: item.total_acw ? formatDuration(item.total_acw) : "-",
        avgAcw: item.avg_acw_time ? formatDuration(item.avg_acw_time) : "-",
        totalHandleTime: item.total_handle_time
          ? formatDuration(item.total_handle_time)
          : "-",
        avgHandleTime: item.avg_handle_time
          ? formatDuration(item.avg_handle_time)
          : "-",
        totalBreakTime: item.total_break_time
          ? formatDuration(item.total_break_time)
          : "-",
        occupancy: item.occupancy || " ",
      };
    });

  useEffect(() => {
    if (!params || reportMode !== "historical") {
      if (reportMode !== "historical") {
        setDataRows([]);
        setTotalRowsFromApi(null);
      }
      return;
    }

    const token = localStorage.getItem(AUTH_TOKEN);
    if (!token) {
      toast.error("Session expired or not logged in. Please sign in again.");
      return;
    }

    const controller = new AbortController();
    setLocalLoading(true);
    setReportFetching(true);

    const queryParams: Record<string, string | number | boolean> = {
      from_date: params.gte,
      to_date: params.lte,
      page: params.page ?? 1,
      page_size: params.page_size ?? 20,
      download: false,
      call_type: params.call_type,
    };
    if (params.user_id != null && params.user_id !== "" && params.user_id !== "All") {
      queryParams.user_id = params.user_id;
    }

    axios
      .get(`${reportingBaseUrl}/telephony/agent-performance`, {
        params: queryParams,
        signal: controller.signal,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        const data = res?.data;
        const results = Array.isArray(data?.results)
          ? data.results
          : Array.isArray(data?.data)
            ? data.data
            : Array.isArray(data)
              ? data
              : [];
        const totalRows =
          data?.total_rows ?? data?.count ?? data?.total ?? results.length;
        setTotalRowsFromApi(
          typeof totalRows === "number" ? totalRows : results.length
        );
        const serverPage = data?.current_page ?? data?.page ?? params.page ?? 1;
        const serverPageSize = data?.page_size ?? params.page_size ?? 20;
        const apiPage = Number(serverPage);
        const pageSizeNum = Number(serverPageSize);
        setPaginationModel({
          page: Math.max(0, apiPage - 1),
          pageSize: pageSizeNum,
        });
        const rowOffset = (apiPage - 1) * pageSizeNum;
        const callType = params.call_type === "outbound" ? "outbound" : "inbound";
        if (results.length > 0) {
          setDataRows(mapResultsToRows(results, callType, rowOffset));
        } else {
          setDataRows([]);
        }
      })
      .catch((err) => {
        if (axios.isCancel(err)) return;
        toast.error(
          err?.response?.data?.message ||
            "Failed to fetch Agent performance report"
        );
        setDataRows([]);
      })
      .finally(() => {
        setLocalLoading(false);
        setReportFetching(false);
      });

    return () => controller.abort();
  }, [params, reportingBaseUrl, reportMode]);

  useEffect(() => {
    if (reportMode !== "live") return;
    if (params) setLocalLoading(true);
  }, [params, reportMode]);

  useEffect(() => {
    if (reportMode !== "live") return;
    if (!Array.isArray(agentPerformanceData)) {
      setDataRows([]);
      setLocalLoading(false);
      return;
    }

    const transformedRows = agentPerformanceData.map((item: any, index: number) => ({
      id: index + 1,
      srNo: index + 1,
      date: item.date || "-",
      agentName: item.agent_name || "-",
      totalLoginTime: item.total_login_time
        ? formatDuration(item.total_login_time)
        : "-",
      totalInboundCalls:
        reportType === "Inbound" ? item.total_calls || "-" : undefined,
      totalOutboundCalls:
        reportType === "Outbound" ? item.total_calls || "-" : undefined,
      totalTalkTime: item.total_talk_time
        ? formatDuration(item.total_talk_time)
        : "-",
      avgTalkTime: item.avg_talk_time
        ? formatDuration(item.avg_talk_time)
        : "-",
      totalHoldTime: item.total_hold_time
        ? formatDuration(item.total_hold_time)
        : "-",
      avgHoldTime: item.avg_hold_time
        ? formatDuration(item.avg_hold_time)
        : "-",
      totalAcw: item.total_acw ? formatDuration(item.total_acw) : "-",
      avgAcw: item.avg_acw_time ? formatDuration(item.avg_acw_time) : "-",
      totalHandleTime: item.total_handle_time
        ? formatDuration(item.total_handle_time)
        : "-",
      avgHandleTime: item.avg_handle_time
        ? formatDuration(item.avg_handle_time)
        : "-",
      totalBreakTime: item.total_break_time
        ? formatDuration(item.total_break_time)
        : "-",
      occupancy: item.occupancy || " ",
    }));

    setDataRows(transformedRows);
    setLocalLoading(false);
  }, [agentPerformanceData, reportMode, reportType]);

  const handleDownload = async () => {
    if (!params) {
      toast.error("Please apply filters and submit before generating the report.");
      return;
    }

    const downloadPayload: Record<string, string | number> = {
      from_date: params.gte,
      to_date: params.lte,
      page: 1,
      page_size: totalRowsFromApi ?? 99999,
      call_type: params.call_type,
    };
    if (
      params.user_id != null &&
      params.user_id !== "" &&
      params.user_id !== "All"
    ) {
      downloadPayload.user_id = params.user_id;
    }

    try {
      await triggerAgentPerformanceDownload(downloadPayload).unwrap();
      toast.success("Report generation in progress. Download from exported report section once ready");
    } catch (err: any) {
      toast.error(err?.data?.message || "Failed to queue report generation.");
    }
  };

  const resetFilters = () => {
    setDateFrom("");
    setDateTo("");
    setParams(null);
    setReportMode(null);
    setSelectedAssignee("");
    setDataRows([]);
    setTotalRowsFromApi(null);
    setPaginationModel({ page: 0, pageSize: 20 });
  };

  const ITEM_HEIGHT = 60;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 150,
      },
    },
  };

  const handlePaginationChange = (newPaginationModel: any) => {
    setPaginationModel(newPaginationModel);
    if (!params) return;
    if (reportMode === "live") return;
    setParams({
      ...params,
      page: newPaginationModel.page + 1,
      page_size: newPaginationModel.pageSize,
    });
  };

  const gridLoading =
    reportMode === "live" ? localLoading || liveReportFetching : localLoading;
  const showSpinner =
    userLoading ||
    (reportMode === "live"
      ? liveReportStatus === "pending"
      : reportFetching || localLoading);

  const activeColumns =
    reportType === "Inbound" ? columnsInbound : columnsOutbound;

  return (
    <div id="kt_app_content_container" className="app-container mx-5">
      <div className="card card-flush">
        {/* Card Header */}
        <div
          className="card-header align-items-center py-1 gap-2 gap-md-5"
          style={{ justifyContent: "flex-start" }}
        >
          {/* Back button */}
          {/* <img
            src="https://insurance.circleonecrm.com/assets/arrow_back.svg"
            alt="Back"
            style={{ marginBottom: "-2px", cursor: "pointer" }}
            className="ng-star-inserted"
            onClick={() => {
              navigate("/reports/telephony/reports-list");
            }}
          /> */}
          <button
            className="btn btn-link mb-2"
            onClick={() => {
              navigate("/reports/telephony/reports-list");
            }}
            style={{ marginRight: "-17px" }}
          >
            <i
              className="bi bi-arrow-90deg-left"
              style={{
                fontSize: "20px",
                color: "black",
                cursor: "pointer",
              }}
            ></i>
          </button>
          <span className="fs-3 text-gray-800 fw-bold ms-3">
            {" "}
            Agent performance
          </span>
        </div>

        {/* Toolbar */}
        <div
          className="card-toolbar flex-row-fluid justify-content-start gap-5 d-flex mb-10"
          style={{ marginLeft: "30px" }}
        >
          <div className="w-100 mw-150px">
            <TextField
              id="date-from"
              label="From"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                inputProps: {
                  max: new Date().toISOString().split("T")[0], // Restrict to today or earlier
                  style: { textTransform: "uppercase" }, // Optional: uppercase input text
                },
              }}
              fullWidth
              value={dateFrom}
              onChange={handleDateFromChange}
            />
          </div>
          <div className="w-100 mw-150px">
            <TextField
              id="date-to"
              label="To"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                inputProps: {
                   max: new Date().toISOString().split('T')[0],
                  style: { textTransform: "uppercase" }, // Optional: uppercase input text
                },
              }}
              fullWidth
              value={dateTo}
              onChange={handleDateToChange}
            />
          </div>

          <div className="w-100 mw-150px">
            <FormControl fullWidth>
              <InputLabel id="select-type">Select Type</InputLabel>
              <Select
                labelId="select-type"
                id="select-type"
                label="Select Type"
                value={reportType}
                onChange={handleReportTypeChange}
              >
                <MenuItem value="Inbound">Inbound</MenuItem>
                <MenuItem value="Outbound">Outbound</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="w-100 mw-150px">
            <FormControl sx={{ width: "200px" }}>
              <InputLabel id="Assignee-select-label">Assignee</InputLabel>
              <Select
                labelId="Assignee-select-label"
                id="Assignee-select"
                label="Assignee"
                MenuProps={MenuProps}
                value={selectedAssignee}
                onChange={handleChange}
              >
                <MenuItem key="all" value="All">
                  All
                </MenuItem>
                {theUser?.map((assignee: any) => (
                  <MenuItem key={assignee.id} value={assignee.id}>
                    {assignee.username}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <div className="ms-auto d-flex gap-3" style={{ marginRight: "20px" }}>
            <button className="btn btn-primary" onClick={handleSubmit}>
              Submit
            </button>

            {reportMode === "live" ? (
              <button
                className="btn btn-primary"
                disabled={!params || dataRows.length === 0}
              >
                <CsvDownloader
                  filename={`${reportType}-performance-report`}
                  datas={dataRows}
                  columns={activeColumns.map((col) => ({
                    id: col.field,
                    displayName: col.headerName,
                  }))}
                  separator=","
                  wrapColumnChar={`"`}
                >
                  Download
                </CsvDownloader>
              </button>
            ) : (
              <button
                className="btn btn-primary"
                onClick={handleDownload}
                disabled={!params || downloadLoading}
              >
                {downloadLoading ? "Loading..." : "Download"}
              </button>
            )}

            <button className="btn btn-link" onClick={resetFilters}>
              <i className="bi bi-funnel fs-2 text-dark"></i>
            </button>
          </div>
        </div>

        <CardContent style={{ width: "100%" }}>
          {showSpinner ? (
            <LoadingSpinner />
          ) : (
            <DataGrid
              rows={dataRows}
              columns={activeColumns}
              pagination
              {...(reportMode === "historical"
                ? {
                    paginationMode: "server" as const,
                    rowCount: totalRowsFromApi ?? 0,
                  }
                : {})}
              paginationModel={paginationModel}
              onPaginationModelChange={handlePaginationChange}
              loading={gridLoading}
              disableColumnMenu
              pageSizeOptions={[5, 10, 15, 20]}
              sx={{
                "& .MuiDataGrid-columnHeader": {
                  backgroundColor: "lightgray",
                  "&:last-child": {
                    justifyContent: "flex-end",
                  },
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "bold",
                },
                "& .MuiDataGrid-columnsContainer": {
                  backgroundColor: "lightgray",
                },
                // Target the pagination select and actions by stable component classes
                "& .MuiTablePagination-select, .MuiTablePagination-actions": {
                  marginBottom: "10px",
                },
                // Target the DataGrid overlay wrapper with its stable class
                "& .MuiDataGrid-overlayWrapper": {
                  height: "50px",
                },
              }}
            />
          )}
        </CardContent>
      </div>
    </div>
  );
};

export default AgentPerformanceReport;
